<template>
  <section class="recommend-service">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-xl-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3 col-lg-6">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회 월" label-for="searchMonth"
                              label-cols="3" content-cols="9">
                  <date-picker id="searchMonth" v-model="selectedMonth"
                               type="month" value-type="YYYY-MM" append-to-body lang="ko"
                               :disabled-date="disabledAfterToday" @input="getUserOptions"/>
                </b-form-group>
              </div>
              <div class="col-xl-3 col-lg-6">
                <b-form-group label-class="col-form-label"
                              label="이용자" label-for="searchUserId"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchUserId" v-model="selectedUser" :options="userOptions"
                               :disabled="isEmptyUserOptions" :placeholder="userPlaceholder"
                               :show-labels="false" :allow-empty="false" deselect-label="">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Summary Card -->
    <div class="row">
      <div class="col-xl-6 align-items-stretch" style="padding-bottom: 20px;">
        <div class="card shadow h-100" >
          <div class="card-body pb-0 d-flex flex-column">
            <card-title icon-image="mdi-table-large" title="충전 요약" text-color="title" />

              <!-- START Info Box -->
              <div class="row flex-grow-1" style="padding-bottom: 20px;">
                <div class="col-lg-4 mobile-inside-card-padding">
                  <small-info-count-to card-bg="" card-class="h-100 mb-0"
                                       icon-image="mdi-cash" icon-color="danger"
                                       title="충전 요금" value-title="원"
                                       :compared="!$_utils.isEmpty(summaryData) ? summaryData.sumTotCostVariation : 0"
                                       :end-val="!$_utils.isEmpty(summaryData) ? summaryData.sumTotCost : 0" />
                </div>
                <div class="col-lg-4 mobile-inside-card-padding">
                  <small-info-count-to card-bg="" card-class="h-100 mb-0"
                                       icon-image="mdi-battery-charging-medium" icon-color="primary"
                                       title="충전량" value-title="kWh"
                                       :compared="!$_utils.isEmpty(summaryData) ? summaryData.sumTotEnergyVariation : 0"
                                       :end-val="!$_utils.isEmpty(summaryData) ? summaryData.sumTotEnergy : 0" />
                </div>
                <div class="col-lg-4">
                  <small-info-count-to card-bg="" card-class="h-100 mb-0"
                                       icon-image="mdi-calendar-clock" icon-color="success"
                                       title="예약 충전" value-title="건"
                                       :compared="!$_utils.isEmpty(summaryData) ? summaryData.reservedCntVariation : 0"
                                       :end-val="!$_utils.isEmpty(summaryData) ? summaryData.reservedCnt : 0" />
                </div>
              </div>

              <div class="row flex-grow-1" style="padding-bottom: 20px;">
                <div class="col-lg-4 mobile-inside-card-padding">
                  <small-info-count-to card-bg="" card-class="h-100 mb-0"
                                       icon-image="mdi-calendar-clock" icon-color="success"
                                       title="충전 건수" value-title="건"
                                       :compared="!$_utils.isEmpty(summaryData) ? summaryData.usedCntVariation : 0"
                                       :end-val="!$_utils.isEmpty(summaryData) ? summaryData.usedCnt : 0" />
                </div>
                <div class="col-lg-4 mobile-inside-card-padding">
                  <small-info-count-to card-bg="" card-class="h-100 mb-0"
                                       icon-image="mdi-clock-time-three" icon-color="info"
                                       title="충전 시간" value-title=""
                                       :compared="!$_utils.isEmpty(summaryData) ? summaryData.sumChargeTimeVariation : 0"
                                       :value-time="!$_utils.isEmpty(summaryData) ? summaryData.sumChargeTime.slice(0, -3).replace(':', '시간 ') + '분' : '-'" />
                </div>
                <div class="col-lg-4">
                  <small-info-count-to card-bg="" card-class="h-100 mb-0"
                                       icon-image="mdi-cash-plus" icon-color="danger"
                                       title="적립금" value-title="원"
                                       :compared="!$_utils.isEmpty(summaryData) ? summaryData.incentivePriceVariation : 0"
                                       :end-val="!$_utils.isEmpty(summaryData) ? summaryData.incentivePrice : 0" />
                </div>
              </div>
              <!-- END Info Box -->

          </div>
        </div>
      </div>

      <div class="col-xl-6 align-items-stretch" style="padding-bottom: 20px;">
        <div class="card shadow h-100 mb-0">
          <div class="card-body pb-0 d-flex flex-column">
            <div class="row justify-content-between">
              <card-title class="col-auto" icon-image="mdi-table-large" title="마이 트렌드" text-color="title" />
              <div class="col-auto">
                <b-button size="sm" variant="outline-deep-green" :disabled="$_utils.isEmpty(myTrendData)" @click="openModal">충전 이력 보기</b-button>
              </div>
            </div>

            <div class="row flex-grow-1">
              <div class="col-lg-4" style="padding-bottom: 20px;">
                <div class="card h-100">
                  <div class="card-body d-flex flex-column">
                    <div class="d-flex justify-content-between">
                      <span class="fw-bold font-size-15">
                        • 이용한 충전소 Top3
                      </span>
                      <span v-if="!$_utils.isEmpty(myTrendData)" class="font-size-13">
                        {{ `(${myTrendData.used_charging_stations.length > 3
                        ? '3'
                        : myTrendData.used_charging_stations.length }/${myTrendData.used_charging_stations.length})` }}
                      </span>
                      <span v-else class="font-size-13">
                        (-/-)
                      </span>
                    </div>

                    <div v-if="!$_utils.isEmpty(myTrendData)" class="flex-grow-1 d-flex flex-column justify-content-around pt-1">
                      <div v-for="(st, i) in myTrendData.used_charging_stations" class="d-flex align-items-center mt-1">
                        <b-badge class="badge badge-soft-deep-green rounded-pill px-2 me-2">
                          {{ i+1 }}
                        </b-badge>
                        <div :class="i === 0 ? 'text-main-green' : ''">{{ st.place_name }}</div>
                      </div>
                    </div>
                    <div v-else class="flex-grow-1 d-flex flex-column justify-content-around pt-1">
                      <div v-for="(st, i) in Array.from({ length: 3 })" class="d-flex align-items-center mt-1">
                        <b-badge class="badge badge-soft-deep-green rounded-pill px-2 me-2">
                          {{ i+1 }}
                        </b-badge>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-8" style="padding-bottom: 20px;">
                <div class="card mb-0">
                  <div class="card-body">
                    <div class="fw-bold font-size-15">
                      • <span class="text-main-green">{{ !$_utils.isEmpty(myTrendData) ? myTrendData.used_charging_stations[0].place_name : '충전소' }}</span> 이용 비교
                    </div>
                    <div class="h-100">
                      <div class="row justify-content-between mt-2">
                        <div class="col text-center mx-2 rounded-3 bg-main-green text-white py-1">나</div>
                        <div class="col text-center mx-2"></div>
                        <div class="col text-center mx-2 rounded-3 bg-secondary text-white py-1">충전소 사용자</div>
                      </div>
                      <div v-for="item in comparisonTable">
                        <div v-if="item.title === '평균 충전 시간'">
                          <div class="row justify-content-around mt-2">
                            <div class="col text-center mx-2 user-bg">{{ !$_utils.isEmpty(myTrendData) ? myTrendData.user[item.value].replace(/(^0+)/, "").replace(':', '시간 ') + '분' : '시간' }}</div>
                            <div class="col text-center mx-2 fw-bold font-size-15">평균 충전 시간</div>
                            <div class="col text-center mx-2 place-bg">{{ !$_utils.isEmpty(myTrendData) ?  myTrendData.place[item.value].replace(/(^0+)/, "").replace(':', '시간 ') + '분' : '시간' }}</div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="row justify-content-around mt-2">
                            <div class="col text-center mx-2 user-bg">{{ `${!$_utils.isEmpty(myTrendData) ? myTrendData.user[item.value] : ''} ${item.unit}` }}</div>
                            <div class="col text-center mx-2 fw-bold font-size-15">{{ item.title }}</div>
                            <div class="col text-center mx-2 place-bg">{{ `${!$_utils.isEmpty(myTrendData) ? myTrendData.place[item.value] : ''} ${item.unit}` }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- END Summary Card -->

    <!-- START Pattern Card -->
    <div class="row">
      <div class="col-12">
        <div class="card shadow">
          <div class="card-body pb-0">
            <div class="row">
              <div class="col-auto">
                <card-title icon-image="mdi-table-large" title="충전 패턴" text-color="title" />
              </div>
              <div class="col">
                <i class="mdi mdi-information-outline fs-5 align-middle" id="user-pattern-tooltip"
                   style="position:relative; cursor:pointer;"/>
                <b-tooltip target="user-pattern-tooltip" placement="left">
                  <pre class="pre-tag-tooltip">한달 간 충전 건수를 통해 사용자의 주요 충전 패턴을 분석하기 위한 차트로,<br/>충전 건수가 동일할 경우 사용량에 따라 최다 이용을 산출함.</pre>
                </b-tooltip>
              </div>

            </div>


            <div class="row">
              <div class="col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <div class="fw-bold font-size-15">
                      • 시간별 충전 현황
                    </div>
                    <div class="d-flex align-items-center my-2">
                      <div class="badge badge-soft-deep-green rounded-pill p-2 me-2">
                        <span class="font-size-14">최다 충전 시간대</span>
                      </div>
                      <div class="fw-bold">
                        {{`${!$_utils.isEmpty(myTrendData) ? myTrendData.user.max_hour : '_'}시`}}
                      </div>
                    </div>
                    <div class="border border-1">
                      <apexchart height="240"
                                 :options="patternTimeChartOptions" :series="patternTimeChartSeries"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <div class="fw-bold font-size-15">
                      • 요일별 충전 현황
                    </div>
                    <div class="d-flex align-items-center my-2">
                      <div class="badge badge-soft-deep-green rounded-pill p-2 me-2">
                        <span class="font-size-14">최다 충전 요일</span>
                      </div>
                      <div class="fw-bold">
                        {{`${!$_utils.isEmpty(myTrendData) ? myTrendData.user.max_day : '_'}요일`}}
                      </div>
                    </div>
                    <div class="border border-1">
                      <apexchart height="240"
                                 :options="patternWeekDaysChartOptions" :series="patternWeekDaysChartSeries"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <div class="fw-bold font-size-15">
                      • 충전기별 이용 현황
                    </div>
                    <div class="d-flex align-items-center my-2">
                      <div class="badge badge-soft-deep-green rounded-pill p-2 me-2">
                        <span class="font-size-14">최다 이용 충전기</span>
                      </div>
                      <div class="fw-bold">
                        {{`${!$_utils.isEmpty(myTrendData) ? myTrendData.user.max_charger : '_'}`}}
                      </div>
                    </div>
                    <div class="border border-1">
                      <apexchart height="240"
                                 :options="patternEvseUseChartOptions" :series="patternEvseUseChartOptions.series" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- End Pattern Card -->

    <!-- START Recommend Card -->
    <div class="row">
      <div class="col-12">
        <div class="card shadow mb-0">
          <div class="card-body pb-0">
            <card-title icon-image="mdi-table-large" title="충전기 추천 서비스" text-color="title" />

            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body pb-0">

                    <div class="row">
                      <div class="col-lg-4 align-items-stretch" style="padding-bottom: 20px;">
                        <div class="card h-100">
                          <div class="card-body">
                            <div class="fw-bold font-size-15">
                              • 나의 선호 시간
                            </div>
                            <div class="row h-50 align-items-center py-3">
                              <div class="col-5 text-center font-size-14">
                                충전 시간대
                              </div>
                              <div class="col-7 text-center font-size-20 fw-bold">
                                {{ !$_utils.isEmpty(evseRecommendationData)
                                ? `${evseRecommendationData.preferred_time_slot.hour[0]}시 - ${evseRecommendationData.preferred_time_slot.hour[evseRecommendationData.preferred_time_slot.hour.length - 1] + 1}시`
                                : '-' }}
                              </div>
                            </div>
                            <hr class="my-0"/>
                            <div class="row h-50 align-items-center py-3">
                              <div class="col-5 text-center font-size-14">
                                충전 요일
                              </div>
                              <div class="col-7 text-center font-size-20 fw-bold">
                                {{ !$_utils.isEmpty(evseRecommendationData) ? `${evseRecommendationData.preferred_time_slot.day}요일` : '-' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4 align-items-stretch" style="padding-bottom: 20px;">
                        <div class="card h-100">
                          <div class="card-body d-flex flex-column">
                            <div class="fw-bold font-size-15">
                              • 추천 충전기
                            </div>
                            <div class="row flex-grow-1">
                              <div class="col-7 d-flex flex-column justify-content-center ps-3">
                                <span class="mb-3">충전소</span>
                                <span class="fw-bold">{{ !$_utils.isEmpty(evseRecommendationData) ? myTrendData.used_charging_stations[0].place_name : ''}}</span>
                              </div>
                              <div class="col-5">
                                <div v-if="!$_utils.isEmpty(evseRecommendationData)" class="h-100 d-flex flex-column justify-content-evenly">
                                  <div v-for="(evse, i) in evseRecommendationData.recommend_evse">
                                      <b-badge class="badge badge-soft-danger rounded-pill font-size-15 py-1 px-2 me-2">
                                        추천 {{ i+1 }}
                                      </b-badge>
                                    <span class="font-size-18 fw-bold">{{ evse }}</span>
                                  </div>
                                </div>
                                <div v-else class="text-center">
                                  <span>-</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="card">
                          <div class="card-body">
                            <div class="fw-bold font-size-15">
                              • 예상 충전 성공률 비교
                            </div>
                            <div class="border border-1">
                              <apexchart height="240"
                                         :options="successRateChartOptions" :series="successRateChartOptions.series" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body pb-0">

                    <div class="row">
                      <div class="col-lg-4 align-items-stretch" style="padding-bottom: 20px;">
                        <div class="card h-100">
                          <div class="card-body">
                            <div class="fw-bold font-size-15">
                              • 요금 최적화
                            </div>
                            <div class="row h-50 align-items-center py-3">
                              <div class="col text-center">
                                <span class="font-size-14 me-3">
                                  총 비용 절감 기회
                                </span>
                                <span class="font-size-20 fw-bold text-danger">
                                  {{ !$_utils.isEmpty(costSavingsData) ? costSavingsData.cost_optimization.sum_saved_cost.toLocaleString() : '-' }}
                                </span>
                                <span class="font-size-14">
                                  원
                                </span>
                              </div>
                            </div>
                            <hr class="my-0"/>
                            <div class="h-50 d-flex justify-content-evenly align-items-center py-3">
                              <div class="text-center">
                                <div>
                                  기존 충전 금액
                                </div>
                                <div>
                                  {{ !$_utils.isEmpty(costSavingsData) ? costSavingsData.cost_optimization.sum_base_cost.toLocaleString() : '-' }}원
                                </div>
                              </div>
                              <div class="text-center">
                                -
                              </div>
                              <div class="text-center">
                                <div>
                                  절감 충전 금액
                                </div>
                                <div>
                                  {{ !$_utils.isEmpty(costSavingsData) ? costSavingsData.cost_optimization.sum_min_cost.toLocaleString() : '-' }}원
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4 align-items-stretch" style="padding-bottom: 20px;">
                        <div class="card h-100 mb-0">
                          <div class="card-body">
                            <div class="fw-bold font-size-15">
                              • 충전요금 절감 가능 이력
                            </div>
                            <div class="common-sticky-table">
                              <b-table ref="reducibleHistoryTable"
                                       class="datatables text-nowrap"
                                       hover outlined show-empty
                                       responsive sticky-header="270px"
                                       selectable select-mode="single"
                                       :fields="recmdByCost.reducibleHistoryFields"
                                       :items="recmdByCost.reducibleHistoryItems"
                                       @row-clicked="checkSelected"
                                       @row-selected="changeRecmdCostbyHistory">
                                <template #empty="scope">
                                  <span>No Data</span>
                                </template>
                                <template #cell(start_time)="data">
                                  {{ $moment(data.item.start_time).locale('ko').format('M월 DD일 (ddd)') }}
                                </template>
                                <template #cell(base_cost)="data">
                                  {{ data.item.base_cost.toLocaleString() }}원
                                </template>
                                <template #cell(min_cost)="data">
                                  {{ data.item.min_cost.toLocaleString() }}원
                                </template>
                                <template #cell(save_cost)="data">
                                  {{ (data.item.base_cost - data.item.min_cost).toLocaleString() }}원
                                </template>
                              </b-table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="card">
                          <div class="card-body">
                            <div class="fw-bold font-size-15">
                              • 요금 구간별 충전 이용
                            </div>
                            <div class="">
                              <apexchart height="70"
                                         :options="costRatePerSectionChart" :series="costRatePerSectionSeries" />
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <div class="card-body">
                            <div class="fw-bold font-size-15">
                              • 추천 시간 및 요금 구간
                            </div>
                              <apexchart ref="recommendByCostChart" height="120" :options="recommendByCostChartOptions"
                                         :series="recommendByCostChartOptions.series"/>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- End Recommend Card -->

    <driver-charging-history-modal v-if="!$_utils.isEmpty(myTrendData)"
                                   ref="driverChargingHistoryModal"
                                   :month="selectedMonth",
                                   :userId="selectedUser"
                                   :usedStation="myTrendData.used_charging_stations" />

  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import CardTitle from "@/views/components/cardTitle.vue";
import smallInfoCountTo from "@/views/components/infoSmallCountTo.vue";
import DriverChargingHistoryModal from "@/views/pages/driver/driverChargingHistoryModal.vue";
import { http } from "@/mdk/auth-api";

export default {
  name: "recommend",
  components: { smallInfoCountTo, CardTitle, Multiselect, DriverChargingHistoryModal },
  data() {
    return {
      selectedMonth: moment().subtract(1,'months').format('YYYY-MM'),
      selectedUser: null,
      userOptions: [],
      userPlaceholder: '',
      isEmptyUserOptions: true,

      summaryData : null,
      chargingPatternData: null,
      evseRecommendationData: null,
      costSavingsData: null,
      myTrendData: null,
      comparisonTable: [
        { title: '요일', value: 'max_day', unit: '' },
        { title: '시간대', value: 'max_hour', unit: '시' },
        { title: '평균 충전 시간', value: 'avg_charging_time', unit: '' },
        { title: '평균 충전량', value: 'avg_tot_energy', unit: 'kWh' },
        { title: '월 충전 건수', value: 'used_count', unit: '건'},
      ],
      // patternTime: null,
      // patternDays: null,
      // patternEves: null,
      patternTimeChartSeries: [],
      patternTimeChartOptions: {
        chart: {
          type: 'line',
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
          animations: {
            easing: 'easeinout',
          },
        },
        xaxis: {
          categories: Array.from({ length: 24 }, (v, i) => i),
          axisTicks: { show: false },
          tooltip: { enabled: false },
          labels: {
            style: {
              fontSize: '11px',
            },
          },
        },
        yaxis: {
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => `${val.toFixed(0)}`,
          },
        },
        tooltip: {
          enabled: true,
          x: { show: false },
          y: {
            formatter: y => `${y.toLocaleString(undefined, {maximumFractionDigits: 0})} 건`,
            title: {
              formatter: seriesName => '',
            }
          }
        },
        colors: [ '#50c080' ],
        stroke: {
          curve: 'smooth',
          width: 1,
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 0
          }
        },
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            borderRadius: 2,
            borderRadiusApplication: 'end',
          }
        },
        noData: {
          text: 'No Data',
          offsetY: -22,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          }
        }
      },
      patternWeekDaysChartSeries: [],
      patternWeekDaysChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
          animations: { enabled: false },
        },
        xaxis: {
          categories: ['월', '화', '수', '목', '금', '토', '일'],
          axisTicks: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: {
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => `${val.toFixed(0)}`,
          },
        },
        tooltip: {
          enabled: true,
          x: { show: false },
          y: {
            formatter: y => `${y.toLocaleString(undefined, {maximumFractionDigits: 0})} 건`,
            title: {
              formatter: seriesName => '',
            }
          }
        },
        colors: [ '#3fb270' ],
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            borderRadius: 2,
            borderRadiusApplication: 'end',
          }
        },
        noData: {
          text: 'No Data',
          offsetY: -22,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          }
        }
      },
      patternEvseUseChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
          animations: { enabled: false },
        },
        series: [],
        xaxis: {
          categories: [],
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: y => `${y.toLocaleString()} 건`
          }
        },
        colors: ['#d0d0d0', '#3fb270'],
        dataLabels: { enabled: false },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
        },
        plotOptions: {
          bar: {
            columnWidth: '55%',
            borderRadius: 2,
            borderRadiusApplication: 'end',
          }
        },
        noData: {
          text: 'No Data',
          offsetY: -22,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          }
        }
      },
      successRateChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
          animations: { enabled: false },
        },
        series: [],
        xaxis: {
          categories: [],
          axisTicks: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: {
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => `${val.toFixed(0)}`,
          },
        },
        tooltip: {
          enabled: true,
          x: { show: false },
          y: {
            formatter: y => `${y}%`,
            title: {
              formatter: seriesName => '',
            }
          }
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'right',
          customLegendItems: ['사용&추천', '미사용&추천', '미사용'],
          markers: {
            fillColors: ['#940d0d', '#d9adad', '#d0d0d0'],
          },
        },
        colors: [],
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            columnWidth: '55%',
            borderRadius: 2,
            borderRadiusApplication: 'end',
            distributed: true,
          }
        },
        noData: {
          text: 'No Data',
          offsetY: -22,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          }
        }
      },
      recmdByCost: {
        reducibleHistoryFields: [
          { key: 'start_time', label: '충전일' },
          { key: 'cso_evse_num', label: '충전기' },
          { key: 'base_cost', label: '기존요금' },
          { key: 'min_cost', label: '추천시 요금' },
          { key: 'save_cost', label: '절감 가능' },
        ],
        reducibleHistoryItems: [],
        savedCost: null,
      },
      costRatePerSectionSeries: [],
      costRatePerSectionChart: {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
          animations: { enabled: false },
        },
        colors: [ '#fef5ee', '#fddbc3', '#f6b991' ],
        stroke: {
          width: 1,
          colors: ['#f6b991']
        },
        xaxis: {
          categories: ['나의 이용'],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '90%',
            borderRadius: 5,
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last',
          },
        },
        dataLabels: {
          style: {
            colors: ['#696969']
          },
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val} kW`,
            title: {
              // formatter: seriesName => '',
            },
          }
        },
        grid: {
          show: false,
          padding: {
            top: -15,
            // right: 0,
            bottom: -15,
            left: 0
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          // offsetY: -3,
          markers: {
            offsetY: 2
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'No Data',
          offsetY: -10,
          style: {
            color: '#858585',
          }
        }
      },
      recommendByCostChartOptions: {
        chart: {
          type: 'rangeBar',
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            rangeBarGroupRows: true,
            dataLabels: {
              hideOverflowingLabels: false
            }
          }
        },
        dataLabels: { enabled: false },
        legend: {
          show: false,
          position: 'top',
          horizontalAlign: 'right',
          customLegendItems: [],
          markers: {
            width: 12,
            height: 10,
            fillColors: [ '#fef5ee', '#fddbc3', '#f6b991' ],
            radius: 0,
          },
        },
        xaxis: {
          type: 'numeric',
          min: 0,
          max: 24,
          tickAmount: 4,
          decimalsInFloat: 0,
          labels: {
            formatter: val => `${val}:00`
          }
        },
        series: [
          { data: [{
              x: '기존 충전 시간대',
              y: []
            }]
          },
          { data: [{
              x: '추천 충전 시간대',
              y: []
            }]
          }
        ],
        grid: {
          padding: {
            top: -20,
            right: 0,
            bottom: 0,
            left: 0
          },
        },
        noData: {
          text: 'No Data',
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        annotations: {
          xaxis: [],
        },
        tooltip: {
          x: {
            formatter: x => x
          },
          y: {
            formatter: y => `${y}시`,
          }
        },
      },
    }
  },
  mounted() {
    const vm = this;

    vm.getUserOptions();
  },
  watch: {
    selectedUser () {
      const vm = this;

      vm.search();
    }
  },
  methods: {
    disabledAfterToday(date) {
      return date > moment().subtract(1, 'months');
    },
    async getUserOptions() {
      const vm = this;
      const _url = `/onmapi/charging-service/search/user/${vm.selectedMonth}`;

      try {
        const res = await http.get(_url);

        vm.userOptions = res.data.items.map(ele => ele.userId);

        if (vm.userOptions.length > 0) {
          vm.selectedUser = vm.userOptions[0];
          vm.isEmptyUserOptions = false;
          vm.userPlaceholder = '';
        } else {
          vm.selectedUser = null;
          vm.isEmptyUserOptions = true;
          vm.userPlaceholder = '추천 대상 이용자가 없습니다.';
        }
      } catch (err) {
        console.error(err);
      }
    },
    async search() {
      const vm = this;

      vm.summaryData = null;
      vm.chargingPatternData= null;
      vm.evseRecommendationData= null;
      vm.costSavingsData= null;
      vm.myTrendData= null;

      if (vm.userOptions.length > 0) {
        await Promise.all([
          vm.getSummaryData(),
          vm.getRecommendData()
        ]);
      } else {
        vm.updateRecommendByCostChart(0)
      }

      vm.updatePatternTimeChart();
      vm.updatePatternWeekDaysChart();
      vm.updatePatternEvseUseChart();
      vm.updateSuccessRateChartOptions();
      vm.updateCostRecommend();
    },
    async getSummaryData() {
      const vm = this;
      const _url = '/onmapi/stats/user-used/summary';

      try {
        const res = await http.get(_url, {
          params: {
            targetMonth: vm.selectedMonth,
            userId: vm.selectedUser,
          }
        });
        vm.summaryData = res.data.items;

      } catch (err) {
        console.error(err);
      }

    },
    async getRecommendData() {
      const vm = this;
      const _url = '/onmapi/charging-service/recommenation';

      try {
        const res = await http.get(_url, {
          params: {
            targetMonth: vm.selectedMonth,
            userId: vm.selectedUser,
          }
        });
        const recommendData = res.data.items[0];

        vm.chargingPatternData = JSON.parse(recommendData.chargingPattern);
        vm.evseRecommendationData = JSON.parse(recommendData.evseRecommendation);
        vm.costSavingsData = JSON.parse(recommendData.costSavings);

        vm.myTrendData = JSON.parse(recommendData.chargingPattern).my_trend;

      } catch (err) {
        console.error(err);
      }

    },
    updatePatternTimeChart() {
      const vm = this;
      const patternTimeData = vm.chargingPatternData ? vm.chargingPatternData.hourly_status : [];
      const countPerTime = patternTimeData.map(ele => ele.used_count);

      vm.patternTimeChartOptions = {
        ...vm.patternTimeChartOptions ,
        ...{ tooltip: {
            y: {
              formatter: (val, opts) =>
                `${val.toLocaleString(undefined, {maximumFractionDigits: 0})} 건 (${patternTimeData[opts.dataPointIndex].energy} kWh)`,
            }
          }
        }
      }
      vm.patternTimeChartSeries = [{ data: countPerTime }];

      // const maxCount = Math.max(...countPerTime);
      // const result = patternTimeData
      //   .filter(ele => ele.used_count === maxCount)
      //   .reduce((maxEle, curEle) => (curEle.energy > maxEle.energy ? curEle : maxEle), { energy: -Infinity });
      //
      // vm.patternTime = `${result.hour}시`;
    },
    updatePatternWeekDaysChart() {
      const vm = this;
      const patternWeekDaysData = vm.chargingPatternData ? vm.chargingPatternData.daily_status : [];
      const countPerDays = patternWeekDaysData.map(ele => ele.used_count);

      vm.patternWeekDaysChartOptions = {
        ...vm.patternWeekDaysChartOptions ,
        ...{ tooltip: {
            y: {
              formatter: (val, opts) =>
                `${val.toLocaleString(undefined, {maximumFractionDigits: 0})} 건 (${patternWeekDaysData[opts.dataPointIndex].energy} kWh)`,
            }
          }
        }
      }
      vm.patternWeekDaysChartSeries = [{ data: countPerDays }];

      // const max = Math.max(...countPerDays);
      // let res = [];
      // countPerDays.filter((ele, i) => {
      //   if (ele === max) {
      //     res.push(patternWeekDaysData[i].day)
      //   }
      // });
      //
      // const maxCount = Math.max(...countPerDays);
      // const result = patternWeekDaysData
      //   .filter(ele => ele.used_count === maxCount)
      //   .reduce((maxEle, curEle) => (curEle.energy > maxEle.energy ? curEle : maxEle), { energy: -Infinity });
      //
      // vm.patternDays = `${result.day}요일`;
    },
    updatePatternEvseUseChart() {
      const vm = this;
      const patternEvseUseData = vm.chargingPatternData ? vm.chargingPatternData.evse_usage_status : [];

      vm.patternEvseUseChartOptions = {
        ...vm.patternEvseUseChartOptions,
        ...{ xaxis: { categories: patternEvseUseData.map(ele => ele.cso_evse_num) },
          series: [{
            name: '타사용자 이용',
            data: patternEvseUseData.map(ele => ele.evse_cnt)
          }, {
            name: '나의 이용',
            data: patternEvseUseData.map(ele => ele.user_cnt)
          }],
        }
      };

      // const maxCount = Math.max(...patternEvseUseData.map(ele => ele.user_cnt));
      // const result = patternEvseUseData
      //   .filter(ele => ele.user_cnt === maxCount)
      //
      // vm.patternEves = result.map(ele => ele.cso_evse_num).join(', ');
    },
    updateSuccessRateChartOptions() {
      const vm = this;
      const successRateData = vm.evseRecommendationData ? vm.evseRecommendationData.comparison_evse : [];
      const usedTypeColor = successRateData.map(ele => {
        switch (ele.type) {
          case 0 : return '#940d0d';
          case 1 : return '#d9adad';
          case 2 : return '#c7c7c7';
        }
      });

      vm.successRateChartOptions = {
        ...vm.successRateChartOptions,
        ...{ xaxis: { categories: successRateData.map(ele => ele.cso_evse_num) },
          series: [{ data: successRateData.map(ele => ele.success_rate) }],
          colors: usedTypeColor
        }
      };
    },
    updateCostRecommend() {
      const vm = this;

      // Update History Table
      vm.recmdByCost.reducibleHistoryItems = vm.costSavingsData ? vm.costSavingsData.pre_history.map((ele, i) => {
        return { ...ele, ...{ index: i } }
      }) : [];
      this.$nextTick(() => this.$refs.reducibleHistoryTable.selectRow(0));

      // Update CostRate Chart
      vm.costRatePerSectionSeries = [{
        name: '경부하',
        data: vm.costSavingsData ? [vm.costSavingsData.charging_ratio.low] : []
      }, {
        name: '중간부하',
        data: vm.costSavingsData ? [vm.costSavingsData.charging_ratio.mid] : []
      }, {
        name: '최대부하',
        data: vm.costSavingsData ? [vm.costSavingsData.charging_ratio.high] : []
      }];

    },
    checkSelected(item, i) {
      if (this.$refs.reducibleHistoryTable.isRowSelected(i)) {
        this.$nextTick(() => this.$refs.reducibleHistoryTable.selectRow(i));
      }
    },
    changeRecmdCostbyHistory(row) {
      const vm = this;

      if (row.length > 0) {
        const rowIdx = row[0].index;

        vm.recmdByCost = { ...vm.recmdByCost };
        vm.updateRecommendByCostChart(rowIdx);
      }
    },
    updateRecommendByCostChart(i) {
      const vm = this;

      const recommendByCostData = vm.costSavingsData ? vm.costSavingsData.recommend_range : [];

      const baseData = [];
      const minData = [];
      const currentMonth = new Date().getMonth() + 1;

      // Chart Range Bar Setting
      if (vm.costSavingsData) {
        if ( recommendByCostData[i].base_hour.slice(-1)[0] + 1 > recommendByCostData[i].base_hour[0] ) {
          baseData.push(
            {
              x: '기존 충전 시간대',
              y: [
                recommendByCostData[i].base_hour[0],
                recommendByCostData[i].base_hour.slice(-1)[0] + 1
              ],
              fillColor: '#2fcb72'
            }
          )
        } else {
          baseData.push(
            {
              x: '기존 충전 시간대',
              y: [
                recommendByCostData[i].base_hour[0],
                24
              ],
              fillColor: '#2fcb72'
            }, {
              x: '기존 충전 시간대',
              y: [
                0,
                recommendByCostData[i].base_hour.slice(-1)[0] + 1
              ],
              fillColor: '#2fcb72'
            }
          )
        }

        if ( recommendByCostData[i].min_hour.slice(-1)[0] + 1 > recommendByCostData[i].min_hour[0] ) {
          minData.push(
            {
              x: '추천 충전 시간대',
              y: [
                recommendByCostData[i].min_hour[0],
                recommendByCostData[i].min_hour.slice(-1)[0] + 1
              ],
              fillColor: '#b20202'
            }
          )
        } else {
          minData.push(
            {
              x: '추천 충전 시간대',
              y: [
                recommendByCostData[i].min_hour[0],
                24
              ],
              fillColor: '#b20202'
            }, {
              x: '추천 충전 시간대',
              y: [
                0,
                recommendByCostData[i].min_hour.slice(-1)[0] + 1
              ],
              fillColor: '#b20202'
            }
          )
        };
      }


      // Chart Annotations Setting
      const _color = {
        light: '#fef5ee',
        heavy :'#fddbc3',
        max:'#f6b991'
      };
      let xRanges;
      if ((currentMonth >= 3 && currentMonth <= 5) || (currentMonth >= 9 && currentMonth <= 10)) {
        xRanges = [
          { x: 0, x2: 8, type: 'light' },
          { x: 8, x2: 11, type: 'heavy' },
          { x: 11, x2: 12, type: 'max' },
          { x: 12, x2: 13, type: 'heavy' },
          { x: 13, x2: 18, type: 'max' },
          { x: 18, x2: 22, type: 'heavy' },
          { x: 22, x2: 24, type: 'light' }
        ];
      } else if (currentMonth >= 6 && currentMonth <= 8) {
        xRanges = [
          { x: 0, x2: 8, type: 'light' },
          { x: 8, x2: 11, type: 'heavy' },
          { x: 11, x2: 12, type: 'max' },
          { x: 12, x2: 13, type: 'heavy' },
          { x: 13, x2: 18, type: 'max' },
          { x: 18, x2: 22, type: 'heavy' },
          { x: 22, x2: 24, type: 'light' }
        ];
      } else {
        xRanges = [
          { x: 0, x2: 8, type: 'light' },
          { x: 8, x2: 9, type: 'heavy' },
          { x: 9, x2: 12, type: 'max' },
          { x: 12, x2: 16, type: 'heavy' },
          { x: 16, x2: 19, type: 'max' },
          { x: 19, x2: 22, type: 'heavy' },
          { x: 22, x2: 24, type: 'light' }
        ];
      }

      const seasonFeeSection = {
        xaxis: xRanges.map(ele => ({
          x: ele.x,
          x2: ele.x2,
          fillColor: _color[ele.type],
          strokeDashArray: 0,
          borderColor: '#FFFFFF00',
          opacity: 0.4,
        })),
      };

      vm.$refs.recommendByCostChart.updateOptions({
        xaxis: {
          type: 'numeric',
          min: 0,
          max: 24,
          tickAmount: 4,
        },
        legend: {
          show: true,
          customLegendItems: recommendByCostData.length > 0 ? recommendByCostData[i].calc_cost : [],
          markers: {
            width: 12,
            height: 10,
            fillColors: vm.costSavingsData ? [ '#fef5ee', '#fddbc3', '#f6b991' ] : ['#ffffff'],
            radius: 0,
          },
        },
        series: [
          { data: baseData },
          { data: minData }
        ],
        annotations : seasonFeeSection,
      });

    },
    openModal() {
      const vm = this;
      vm.$refs.driverChargingHistoryModal.show = true;
    },
  }
}
</script>